import moment from 'moment-timezone'

/**
 * Returns true if the given DD/MM/YYYY string represents a valid, complete date.
 */
export function isValidBRDate(br: string): boolean {
  if (!br || br.includes('_')) return false
  const m = moment(br, 'DD/MM/YYYY', true)
  return m.isValid()
}
